<template>
  <b-modal
    id="deletecreditpayment"
    size="sm"
    ref="modal"
    body-class="bg-white"
    cancel-title="close"
    cancel-variant="light"
    :ok-title-html="submitted==true?loaderIcon+'Yes':'Yes'"
    :no-close-on-backdrop="true"
    title="Delete Applied credits"
    @ok="deletecreditpaymentrecord"
  >
    <p>Are you sure you want to delete the credits applied to invoice?</p>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
import store from "@/store/index";
import { notificationMixin } from "@/mixins/notification";
export default {
  props: ["CreditDeleteDetail"],
  mixins: [notificationMixin], // for showing message notification
  name: "DeleteCreditRecord",
  data() {
    return {
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false,
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center" // class for notification message design
    };
  },
  methods: {
    deletecreditpaymentrecord() {
      this.submitted = true;
      store
        .dispatch(
          "invoice/deletecreditpaymentrecord",
          JSON.stringify({ id: this.CreditDeleteDetail.inv_pymnt_id })
        )
        .then(() => {
          this.submitted = false;
          if(this.status_code == 200){
              if (this.$route.name == "CreditView") {
            this.$emit("setAmountDetails", {
              CreditDeleteDetail: this.CreditDeleteDetail
            });
          }
           this.$emit("recallRecord",{
              PaymentDeleteDetail: this.PaymentDeleteDetail
            })
          }
          
        
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
             message: this.status_message,
            type: this.status_type,
            showCloseButton: true,
          });
        
        });
    }
  },
  created() {
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  computed: {
    ...mapState({
      invoice_credit_updated_details: state =>
        state.invoice.invoice_credit_details,
      message: state => state.invoice.message,
       status_code: (state) => state.invoice.status_code,
      status_message: (state) => state.invoice.status_message,
      status_type: (state) => state.invoice.status_type,
    }),
    //  to update applied credit amount in the invoice page
    invoice_credit_details: {
      get() {
        return this.$store.state.invoice.list.invoice_credit_details;
      },
      set(val) {
        this.$store.state.invoice.list.invoice_credit_details = val;
      }
    },
    // to update balce due amount after inovice credit update
    invoice_amount_detail: {
      get() {
        return this.$store.state.invoice.list.invoice_amount_detail;
      },
      set(val) {
        this.$store.state.invoice.list.invoice_amount_detail = val;
      }
    },
    // to udpate the credit details tab
    available_credits: {
      get() {
        return this.$store.state.invoice.list.available_credits;
      },
      set(val) {
        this.$store.state.invoice.list.available_credits = val;
      }
    }
  }
};
</script>

<style>
</style>
